export default {
  errors: {
    name: {
      NOT_UNIQUE_ERROR: 'Un statut d\'alerte du même nom existe déjà dans cet établissement'
    }
  }
}
